import script from "./ButtonFixedDark.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonFixedDark.vue?vue&type=script&setup=true&lang=js"

import "./ButtonFixedDark.vue?vue&type=style&index=0&id=7529a149&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7529a149"]])

export default __exports__